import { Alert, AlertDescription, AlertIcon, AlertTitle } from "@chakra-ui/react";
import { Bundle, Resource } from "@medplum/fhirtypes";
import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { useMemo } from "react";
import { PatientOverviewV2Content } from "../patient-overview-v2-content";
import { PatientQueryParamProps } from "../shared-logic/consolidated-context/reducer";
import useRemoteJsonFile from "../shared-logic/useRemoteJsonFile";
import PatientOverviewContent from "./preview-patient-overview-content";

export function PreviewPatientOverview({
  patientQueryParams,
}: {
  patientQueryParams?: PatientQueryParamProps;
}) {
  const params = new URLSearchParams(window.location.search);
  const encodedUrl = params.get("url");

  return <PatientOverviewContent url={encodedUrl} patientQueryParams={patientQueryParams} />;
}

export function PreviewPatientOverviewV2() {
  const params = new URLSearchParams(window.location.search);
  const encodedUrl = params.get("url");

  const { data, status, error } = useRemoteJsonFile<Bundle<Resource>>(encodedUrl);

  const fhirSdk = useMemo(() => {
    if (!data) return undefined;
    return FhirBundleSdk.createSync(data);
  }, [data]);

  const isLoadingData = status === "loading";

  if (status === "error") {
    return (
      <Alert status="error">
        <AlertIcon />
        <AlertTitle>Error loading FHIR Bundle</AlertTitle>
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
    );
  }

  return (
    <PatientOverviewV2Content
      fhirSdk={fhirSdk}
      children={null}
      isImpersonating={false}
      isLoadingData={isLoadingData}
      consolidated={data ?? undefined}
      patientId="dummy-patient-id" // for document export local storage
    />
  );
}
